import React, { useState, useEffect } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { Text, Colors, SmallIconButton, SmallIcon } from 'library';
import { client } from 'shared';
import theme from 'theme';
import ProviderProfileImage from 'parent-portal/provider-profile/ProviderProfileImage';
import { Message } from '@material-ui/icons';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BusinessEnrollmentModal from './BusinessEnrollementModal';

export default function BusinessesOverview() {
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    const [businesses, setBusinesses] = useState<any[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    useEffect(() => {
        client(`api/business/enrolled`).then(setBusinesses);
    }, []);

    function getTypes(business: any) {
        let offerings = '';
        business.care_offerings.forEach((offering: any) => {
            offerings += `, ${offering.care_offering_type.name}`;
        });
        offerings = offerings.substring(1, offerings.length);
        return offerings;
    }
    return (
        <Grid container justify="center" style={{ width: '100%', padding: '2%' }}>
            <Grid container item justify="center" xs={12}>
                <Text variant="display" textStyle={{ margin: 35 }}>
                    Child Care Centers Near You
                </Text>
            </Grid>
            <Grid container item sm={7} xs={9}>
                {businesses
                    ? businesses.map((business, index) => (
                          <Grid
                              container
                              direction="row"
                              xs={12}
                              alignItems="center"
                              justify="center"
                              style={{
                                  borderBottomStyle: `solid`,
                                  borderBottomColor: Colors.lightGrey,
                                  backgroundColor: Colors.white,
                                  paddingBottom: 30,
                                  marginTop: '2%',
                              }}
                          >
                              <Grid container item sm={3} xs={12} alignItems="center" justify="center">
                                  <Grid item style={{ top: 100 }}>
                                      <ProviderProfileImage business={business} mobile={true} />
                                  </Grid>
                              </Grid>
                              <Grid container item sm={8} xs={9}>
                                  <Grid
                                      container
                                      item
                                      xs={12}
                                      onClick={() => {
                                          let url = `${window.location.origin}/businesses/${business.id}`;

                                          window.open(url, '_blank');
                                      }}
                                  >
                                      <Text
                                          variant="h2"
                                          bold
                                          textStyle={{ textDecoration: 'underline', cursor: 'pointer' }}
                                      >
                                          {business.name}
                                      </Text>
                                  </Grid>
                                  <Grid container item xs={12}>
                                      <Text variant="body2">
                                          {business.user.address[0].city}, {business.user.address[0].state}
                                      </Text>
                                  </Grid>
                                  <Grid container item xs={12}>
                                      <div
                                          style={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                          }}
                                      >
                                          <SmallIcon
                                              icon={<FamilyRestroomIcon fontSize={'small'} />}
                                              backgroundColor={Colors.lightTurq}
                                              style={{ marginRight: 10, marginTop: 10 }}
                                          />
                                          <div style={{ flexDirection: 'column' }}>
                                              <Text variant="body2" bold textStyle={{ marginTop: 10 }}>
                                                  Type
                                              </Text>
                                              {!!business.care_offerings ? (
                                                  <Text variant="body2">
                                                      {business.type.charAt(0) +
                                                          business.type.substring(1).toLowerCase()}{' '}
                                                      providing care for {getTypes(business)}
                                                  </Text>
                                              ) : null}
                                          </div>
                                      </div>
                                  </Grid>
                                  <Grid container item xs={12}>
                                      <div
                                          style={{
                                              display: 'flex',
                                              flexDirection: 'row',
                                          }}
                                      >
                                          <SmallIcon
                                              icon={<AccessTimeIcon fontSize={'small'} />}
                                              backgroundColor={Colors.lightTurq}
                                              style={{ marginRight: 10, marginTop: 10 }}
                                          />
                                          {business.total_available_spots ? (
                                              <div style={{ flexDirection: 'column' }}>
                                                  <Text variant="body2" bold textStyle={{ marginTop: 10 }}>
                                                      Availability
                                                  </Text>
                                                  <Text variant="body2">
                                                      {business.total_available_spots} open spots
                                                  </Text>
                                              </div>
                                          ) : null}
                                      </div>
                                  </Grid>
                              </Grid>
                              <Grid container item sm={1} xs={3}>
                                  <SmallIconButton
                                      icon={Message}
                                      onClick={() => setOpen(true)}
                                      backgroundColor={Colors.white}
                                      shadow={true}
                                      hoverText="Message Provider"
                                      style={{ marginRight: 10, marginTop: 10 }}
                                  />
                                  {business.min_rate ? (
                                      <Text variant="caption" bold textStyle={{ alignSelf: 'flex-end', marginTop: 30 }}>
                                          Starting at ${business.min_rate}/month
                                      </Text>
                                  ) : null}
                              </Grid>
                              <BusinessEnrollmentModal business={business} open={open} onClose={() => setOpen(false)} />
                          </Grid>
                      ))
                    : null}
            </Grid>
        </Grid>
    );
}
